import { TenantSyncStateEnum } from '@reach/shared-types/tenant-filter';
import { TENANT_SYNC_STATE_LABEL } from './engage-library-utils';
import styles from './TenantSyncStatusPill.module.css';

interface TenantSyncStatusPillProps {
  status: TenantSyncStateEnum;
}

export function TenantSyncStatusPill({ status }: TenantSyncStatusPillProps) {
  return (
    <span className={styles.pill} data-status={status}>
      <span className={styles.dot} />
      {TENANT_SYNC_STATE_LABEL[status]}
    </span>
  );
}
